// Function to get the authorization header

export function authHeader() {
    let user = JSON.parse(window.sessionStorage.getItem('adminuser'));
    if (user && user.token) {
        // You can keep a general log for debugging in development (optional)
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        console.error('No valid token found.'); // Log if no token is found
        return {};
    }
}


// Function to handle logout
export function logoutFunction() {
    window.sessionStorage.removeItem('adminuser');
    window.location.href = "/login"
    // window.location.replace('/login');
    // window.location.reload();
}

// Common header for public API requests
export const headerForPublicAPI = {
    'Content-Type': 'application/json',
};

// Header for private API requests (with Authorization)
export const headerForPrivateAPI = () => {
    const header = {
    }
    const token = authHeader().Authorization
    header["Content-Type"] = "application/json"
    header["Authorization"] = token
    return header
}


// Header for private media API requests
export const headerForPrivateMediaAPI = {
    'Content-Type': 'multipart/form-data',
    ...authHeader(), // Spread the `Authorization` token here from `authHeader`
};

// Function to call the API
function toQueryParams(data) {
    return Object.entries(data)
        .map(([key, value]) =>
            encodeURIComponent(key) + '=' + encodeURIComponent(value)
        )
        .join('&');
}

export const APIcallFunction = async (credentials) => {
    // const baseUrl = "http://localhost:1223/api/v1";
    // const baseUrl = "https://dev-jb-corp.jamsara.com/api/v1";
    // const baseUrl = "https://apisuperadmin.jbcweighingscale.in/api/v1";
    const baseUrl = "https://admin.jbcweighingscale.in/api/v1";
    // const baseUrl = "https://jb-corp-backend.vercel.app/api/v1";
    const requestOptions = {
        method: credentials.method,
        headers: credentials.header || { 'Content-Type': 'application/json' }
    };

    if (credentials.method === "GET" && credentials.body) {
        credentials.endPoint += `?${toQueryParams(credentials.body)}`
    } else {
        requestOptions.body = credentials.body ? JSON.stringify(credentials.body) : null
    }

    try {
        const response = await fetch(baseUrl + credentials.endPoint, requestOptions);
        const responseData = await handleResponse(response);

        return {
            data: responseData.data,
        };
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

// Handle the response from the API
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (data.code === 1 && data.message === "Send valid token") {
            logoutFunction();
        }
        if (!response.ok) {
            if (response.status === 401) {
                logoutFunction(); // Handle unauthorized access by logging out
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (data.error) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
